import { useEffect, useState } from "react";
import "./style.css";

const ToggleBtn3Op = ({ theme }) => {


  const [toggle, setToggle] = useState(localStorage.getItem('theme'));

  useEffect(() => {
    theme(toggle);
    localStorage.setItem('theme',toggle)

  }, [toggle, theme]);

  const clicToggle = () => {

    if (toggle === 'dark' || toggle === 'null' || toggle===null) setToggle('light')
    else if (toggle === 'system') setToggle('dark')
    else if (toggle === 'light') setToggle('system')

  }

  return (
    <>
      <div className="container" onClick={clicToggle}>
        <div className="elements">
          <section className="material-icons-outlined">light_mode</section>
          <section className="material-icons-outlined">mode_standby</section>
          <section className="material-icons-outlined">dark_mode</section>
        </div>
        <div className={'selector ' + toggle} />


      </div>
    </>
  );
};

export default ToggleBtn3Op;
